import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {TRIGGER_LAST_PAYLOAD_QUERY_KEY} from "../queryKeys";
import {LastInteractionPayload, TriggerInteractionType} from "./types";

type Variables = {interactionType: TriggerInteractionType};

const getLastTriggerPayload = async (variables: Variables): Promise<LastInteractionPayload> => {
  const response = await axiosReachInstance.get<LastInteractionPayload, AxiosResponse<LastInteractionPayload>>(
    `/triggers/last-payload/${variables.interactionType}`
  );
  return response.data;
};

export const useGetLastTriggerPayload = (
  variables: Variables,
  options?: BaseQueryOptions<LastInteractionPayload, Variables>
): BaseUseQueryResult<LastInteractionPayload> => {
  return useBaseQuery<LastInteractionPayload, Variables>(
    [TRIGGER_LAST_PAYLOAD_QUERY_KEY, variables.interactionType],
    getLastTriggerPayload,
    variables,
    options
  );
};
